import React, { useState, useRef, useEffect } from 'react'
import { gsap } from 'gsap'

const TxtlssHero = () => {
  const [gif, setGif] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setGif(gif => gif + 1)
    }, 5000)

    return () => clearInterval(interval)
  }, [])

  useEffect(
    () => {
      if (gif > 11) {
        setGif(0)
      }
    },
    [gif]
  )

  const logoRef0 = useRef(null)

  useEffect(() => {
    const el = logoRef0.current

    const tween = gsap.timeline({
      repeat: -1,
      repeatDelay: 4,
      yoyo: true,
    })

    tween
      .set(el, {
        webkitFilter: `brightness(random(90,110)%) grayscale(0%) blur(0)`,
        webkitTransform: `scale(1)`,
      })
      .to(el, {
        duration: 0.1,
        webkitFilter: `brightness(random(140,180)%) grayscale(random(0,100)%) blur(random(1,5)px) contrast(100%)`,
        webkitTransform: `scale(random(0.99,1.01))`,
      })
      .to(el, {
        duration: 0.5,
        webkitFilter: `brightness(100%) grayscale(random(0,30)%) blur(0) contrast(80%)`,
        webkitTransform: `scale(1)`,
      })
      .to(el, {
        duration: 0.5,
        webkitFilter: `brightness(100%) grayscale(random(0,30)%) blur(0) contrast(100%)`,
      })
  }, [])

  const logoRef = useRef(null)

  useEffect(() => {
    const el = logoRef.current

    const tween = gsap.timeline({
      repeat: -1,
      repeatDelay: 2,
      yoyo: true,
    })

    tween
      .set(el, {
        webkitClipPath: `inset(300px 0 300px 0)`,
      })
      .to(el, {
        webkitClipPath: `inset(random(130, 150)px 0 random(70, 110)px 0)`,
        duration: 0.3,
        left: 0,
      })
      .to(el, {
        webkitClipPath: `inset(random(140, 160)px 0 random(60, 100)px 0)`,
        webkitFilter: `brightness(100%)`,
        left: `random(-10, 10)px`,
        duration: 0.5,
      })
      .to(el, {
        webkitClipPath: `inset(random(150, 170)px 0 random(50, 90)px 0)`,
        webkitFilter: `brightness(random(80,130)%)`,
        left: 0,
        duration: 0.4,
      })
      .to(el, {
        webkitClipPath: `inset(300px 0 300px 0)`,
        webkitFilter: `brightness(100%)`,
        duration: 0.2,
      })
  }, [])

  const logoRef2 = useRef(null)

  useEffect(() => {
    const el = logoRef2.current

    const tween = gsap.timeline({
      repeat: -1,
      repeatDelay: 1,
      yoyo: true,
    })

    tween
      .set(el, {
        webkitClipPath: `inset(100px 0 500px 0)`,
        filter: `brightness(100%)`,
        left: 0,
      })
      .to(el, {
        webkitClipPath: `inset(random(70, 90)px 0 random(160, 200)px 0)`,
        filter: `brightness(random(140,180)%)`,
        left: `random(-15, 15)px`,
        duration: 0.3,
      })
      .to(el, {
        webkitClipPath: `inset(random(80, 120)px 0 random(150, 170)px 0)`,
        left: 0,
        duration: 0.5,
      })
      .to(el, {
        webkitClipPath: `inset(random(90, 130)px 0 random(120, 140)px 0)`,
        duration: 0.1,
      })
      .to(el, {
        webkitClipPath: `inset(100px 0 500px 0)`,
        duration: 0.3,
      })
  }, [])

  return (
    <>
      <h1
        ref={logoRef0}
        className={`u-text-p1 u-Mt-xl txtlss-h1 glitch gif${gif}`}
        data-text=".txtlss"
      >
        .txtlss
        <span ref={logoRef} className="glitchedText">
          .txtlss
        </span>
        <span ref={logoRef2} className="glitchedText1">
          .txtlss
        </span>
      </h1>
    </>
  )
}

export default TxtlssHero
